import LoginScreen from "@/src/screens/auth/login-screen/login-screen";

function loginPage() {
  return <LoginScreen />;
}

export default loginPage;
